module.exports = __webpack_public_path__ + "static/media/alfred_icon.f1003830.png";